<template>
<Dialog header="Sertifika İptal Nedeni" 
v-model:visible="show_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '80vw'}"
:modal="true"
>

<Textarea v-model="rejection_note" rows="5"  class="w-full p-inputtext-sm animate_class" />

<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" />

<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-times" @click="submit" class=" p-button-primary p-button-outlined  p-button-sm" />
</template>



</Dialog>
</template>

<script>
export default {

  name: 'CertificateRejectionModal',
  data () {
    return {
    	show_modal:false,
    	rejection_note:"",
    	cert_id:null,
    }
  },
  methods:{
  	showModal(id)
  	{
  		this.cert_id = id
  		this.show_modal = true
  	},
  	hideModal()
  	{
  		this.show_modal = false
  		this.cert_id = null
  		this.rejection_note = ""
  	},
  	submit()
  	{
  		if(this.rejection_note=="")
  		{
  			this.showMessage("error","Lütfen metin girin")
  			return
  		}
  		else
  		{
  			this.$emit("rejected",{id:this.cert_id,rejection_note:this.rejection_note})
  		}
  		
  		setTimeout(()=>{
  			this.hideModal()
  		})
  	},
  },
}
</script>

<style lang="css" scoped>
</style>